import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export enum SpinnerType {
    Car = "car-spinner",
    Upholstery = "car-spinner-upholstery",
}

export type CarConfigSpinNavigationStateType = {
    activeSpin: SpinnerType;
};

const initialStateCarConfigSpinNavigation: CarConfigSpinNavigationStateType = {
    activeSpin: SpinnerType.Car,
};

export type CarConfigSpinNavigationActionsType = ReturnType<typeof setActiveSpin>;

export const CarConfigSpinNavigationSlice = createSlice({
    name: "carConfigSpinNavigation",
    initialState: initialStateCarConfigSpinNavigation,
    reducers: {
        setActiveSpin(state, action: PayloadAction<SpinnerType>) {
            return {
                ...state,
                activeSpin: action.payload,
            };
        },
    },
});

export const { setActiveSpin } = CarConfigSpinNavigationSlice.actions;
